module.exports = __webpack_public_path__ + "static/media/tree.335959e3.png";